import { SearchCriterion } from '@App/stores/search/models/search-criterion'

/** Suffix put on a criterion's key when its "Exact Match" toggle is on. */
export const EXACT_MATCH_SUFFIX = 'Exact'

export const mapCriteriaToObject = <T extends Record<string, any>>(
    searchCriteria: Array<SearchCriterion<T>>
): Partial<T> =>
    searchCriteria.reduce((resultValue, { searchTerm, selectedOption, exactMatchOnly }) => {
        if (searchTerm) {
            const selectedProperty = exactMatchOnly
                ? `${selectedOption.value}${EXACT_MATCH_SUFFIX}`
                : selectedOption.value
            setResultValue(resultValue, selectedProperty, searchTerm, !!selectedOption.forceArray)
        }
        return resultValue
    }, {} as T)

/* Some trickery to work-around issues setting property values on generics.
   If the property we're adding already exists, switch it to an array if it's not already, then add the value -
   otherwise, add the value as a regular field */
const setResultValue = <Z extends PropertyKey>(obj: Record<Z, any>, prop: Z, value: any, forceArray: boolean) => {
    if (prop in obj) {
        Array.isArray(obj[prop]) ? obj[prop].push(value) : (obj[prop] = [obj[prop], value])
    } else {
        obj[prop] = forceArray ? [value] : value
    }
}
